import { render, staticRenderFns } from "./Dropdown.vue?vue&type=template&id=37b05034"
import script from "./Dropdown.ts?vue&type=script&lang=ts&external"
export * from "./Dropdown.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports